import React, { useContext } from 'react'
import Like from '../../assests/images/like.svg'
import Dislike from '../../assests/images/dislike.svg'
import diamond from '../../assests/images/diamond.svg'
import Play_btn from '../../assests/images/PLay_btn.svg'
import banner from '../../assests/images/detail_game.png'
import Back from '../Header/Back'
import { Link } from 'react-router-dom'
import Footer from '../footer/Footer'
import Loader from '../../assests/images/loader.gif'
import { useMutation, useQuery } from '@tanstack/react-query'
import { ALLFeaturedGameList, ALLGames, Games, likeDislike } from '../../utils/Api'
import { DataContext } from '../../context/DataContext'
import { useQueryClient } from '@tanstack/react-query';


const AllFeaturedGames = (props) => {
  const queryClient = useQueryClient();
  const { data: contextData, loading, error, refetch } = useContext(DataContext);

  const { mutate } = useMutation({
    mutationFn: async ({ user_id, contest_id, selection_type, idtoken }) => await likeDislike({ user_id, contest_id, selection_type, idtoken }),
    onSuccess: () => {
      queryClient.invalidateQueries(['allfeaturedgamelist']);
    },
  })

  const { data: gameList, isLoading: gameLoading, isError: gameListError, refetch: gameListRefatch } = useQuery({
    queryKey: ['allfeaturedgamelist'],
    queryFn: async () => await ALLFeaturedGameList({ user_id: contextData?.user_id })
  })


  if (gameLoading || loading) return <div className="body_area22">
    <div className="cointainr loader">
      <img src={Loader}></img>
    </div></div>;

  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <Back url={'/'}></Back>
      <div class="body_area22">
        <div class="cointainr">
          <div class="column_area mrgin_top">
            {gameList?.result?.map((data, idx) => (
              <div className="card22 d_flx2 card_list">
                <div className="top_img_card2">
                  <img
                    src={data.app_icon_transparent}
                    alt="knife"
                    className="card2_main_img img_sq"
                  />
                </div>
                <div className="mt_5per colmn">
                  <div className="displ_lr">
                    <p className="ttl_bg">{data.title}</p>
                    {/* Optional: If this needs to be clickable, move it OUTSIDE the main anchor */}
                    <img
                      src={data.is_liked == '1' ? Like : Dislike}
                      onClick={() => {
                        data?.is_liked == '1' ? mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 0, idtoken: contextData?.idtoken }) : mutate({ user_id: contextData?.user_id, contest_id: data.contest_id, selection_type: 1, idtoken: contextData?.idtoken })
                      }}
                      alt="like"
                      className="view_more_btn brdr_none"
                    />
                  </div>
                  <p className="desc">{data.contest_description}</p>
                  <div className="win_daim btn_tp mt_5per">
                    <img src={diamond} alt="diamond" />
                    {data.total_prize}
                  </div>
                  <Link to={`/Details/${data.contest_id}`}>
                    <button className="play_now brdr_10">
                      <img src={Play_btn} alt="play" />
                      Play to Earn
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <Footer></Footer>
        </div>
      </div>
    </div>

  )
}

export default AllFeaturedGames
